export enum ValidationStatus {
  VALID = 'valid',
  INVALID = 'invalid',
}
